import {DashboardStoreUpdateType} from "./DashboardStoreUpdateType";
import {DashboardLayout, DashboardViewConfiguration, WidgetOptions} from "../../models/DashboardViewConfiguration";
import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {AddDashboardConfiguration} from "../../dialog/add-dashboard/models/AddDashboardConfiguration";

export interface DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType;
}

export interface DashboardSecurityUpdate extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.SECURITY;
    readonly dashboard: number;
    readonly security: CodeAndExchange;
}

export function dashboardSecurityUpdate(security: CodeAndExchange, dashboard: number): DashboardSecurityUpdate {
    return {
        type: DashboardStoreUpdateType.SECURITY,
        dashboard,
        security
    };
}

export function isSecurityUpdate(update: DashboardStoreUpdate): update is DashboardSecurityUpdate {
    return update.type === DashboardStoreUpdateType.SECURITY;
}

export interface DashboardSyncUpdate extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.SYNC;
    readonly configuration: DashboardViewConfiguration;
}

export function dashboardSyncUpdate(configuration: DashboardViewConfiguration): DashboardSyncUpdate {
    return {
        type: DashboardStoreUpdateType.SYNC,
        configuration
    };
}

export function isSyncUpdate(update: DashboardStoreUpdate): update is DashboardSyncUpdate {
    return update.type === DashboardStoreUpdateType.SYNC;
}

export interface DashboardWidgetUpdate extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.UPDATE_WIDGET;
    readonly dashboard: number;
    readonly widget: number;
    readonly options: WidgetOptions;
}

export function dashboardWidgetUpdate(dashboard: number,
                                      widget: number,
                                      options: WidgetOptions): DashboardWidgetUpdate {
    return {
        type: DashboardStoreUpdateType.UPDATE_WIDGET,
        dashboard,
        widget,
        options
    };
}

export function isWidgetUpdate(update: DashboardStoreUpdate): update is DashboardWidgetUpdate {
    return update.type === DashboardStoreUpdateType.UPDATE_WIDGET;
}

export interface DashboardWidgetRemove extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.REMOVE_WIDGET;
    readonly dashboard: number;
    readonly widget: number;
}

export function dashboardWidgetRemove(dashboard: number, widget: number): DashboardWidgetRemove {
    return {
        type: DashboardStoreUpdateType.REMOVE_WIDGET,
        dashboard,
        widget
    };
}

export function isWidgetRemove(update: DashboardStoreUpdate): update is DashboardWidgetRemove {
    return update.type === DashboardStoreUpdateType.REMOVE_WIDGET;
}

export interface AddDashboardUpdate extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.ADD_DASHBOARD;
    readonly name: string;
    readonly layout: DashboardLayout;
}

export function addDashboardUpdate(config: AddDashboardConfiguration): AddDashboardUpdate {
    return {
        type: DashboardStoreUpdateType.ADD_DASHBOARD,
        name: config.name,
        layout: config.layout
    };
}

export function isAddDashboardUpdate(update: DashboardStoreUpdate): update is AddDashboardUpdate {
    return update.type === DashboardStoreUpdateType.ADD_DASHBOARD;
}

export interface RemoveDashboardUpdate extends DashboardStoreUpdate {
    readonly type: DashboardStoreUpdateType.REMOVE_DASHBOARD;
    readonly dashboard: number;
}

export function removeDashboardUpdate(dashboard: number): RemoveDashboardUpdate {
    return {
        type: DashboardStoreUpdateType.REMOVE_DASHBOARD,
        dashboard
    };
}

export function isRemoveDashboardUpdate(update: DashboardStoreUpdate): update is RemoveDashboardUpdate {
    return update.type === DashboardStoreUpdateType.REMOVE_DASHBOARD;
}
